function PerformanceExportListCtrl($scope, managementUserOrganizationMemberService) {
  const organizationMember = managementUserOrganizationMemberService.getCurrentOrganizationMember();

  if (!organizationMember) throw new Error('organizationMember required');

  $scope.organizationMemberId = organizationMember.id;
  $scope.dataExportType = [
    'ADMISSION_DUMP',
    'GUESTLIST_BY_ATTRIBUTION_DUMP',
    'GUESTLIST_BY_ATTRIBUTION_SOURCE_XLSX_DUMP',
    'TLPRO_RESERVATION_DUMP',
    'RESERVATION_BY_ATTRIBUTION_DUMP'
  ];
}

PerformanceExportListCtrl.$inject = [
  '$scope',
  'managementUserOrganizationMemberService'
];

export default PerformanceExportListCtrl;



// WEBPACK FOOTER //
// ./src/components/performanceExportList/performanceExportListCtrl.js